import { render, staticRenderFns } from "./ButtonIconMini.vue?vue&type=template&id=41e546a1&scoped=true"
import script from "./ButtonIconMini.vue?vue&type=script&lang=js"
export * from "./ButtonIconMini.vue?vue&type=script&lang=js"
import style0 from "./ButtonIconMini.vue?vue&type=style&index=0&id=41e546a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e546a1",
  null
  
)

export default component.exports